<template>
  <div v-if="firstloading" class="team">
    <!-- {{item.award_info.condition_desc}} -->
    <!-- @load="getteams" -->
    <!-- <van-list v-model="van_list_load" :finished="complete" finished-text="" @load="getteams"> -->
    <div class="team-wrap">
      <div class="couponslist-list" v-for="(item,i) in myawardlist" :key="i">
        <div class="couponslist-item flex-row" :class="item.isShow==true?'active':''">
          <div
            class="couponslist-item-left flex-column"
            :class="{'couponslist-item-left2':item.status == 1}"
          >
            <div class="couponslist-item-left-num">
              <span>{{item.award_info.val_info}}</span>
              {{item.award_info.unit}}
            </div>
            <div
              v-if="item.award_info.condition_desc"
              class="couponslist-item-scope"
            >{{item.award_info.condition_desc}}</div>
          </div>
          <div class="couponslist-item-right flex-column">
            <div class="flex-row couponslist-item-top">
              <div class="flex-column">
                <div
                  class="couponslist-item-name"
                  :class="{'couponslist-item-name2':item.status == 1}"
                >{{item.award_info.award_name}}</div>
                <!-- 请于{{item.expires_code}}前领取/使用 v-if="item.status == 0"-->
                <div class="couponslist-item-time">请于{{item.expires_code}}前领取</div>
              </div>
              <template v-if="item.status == 0">
                <div v-if="isapp" class="couponslist-item-btns flex-row" @click="useAward(i)">
                  <!-- 立即领取 lu注释，原因：APP与微信内显示文案不一致-->
                  {{item.issku==1 ? '立即使用' : '立即领取'}}
                </div>
                <div
                  v-else
                  class="couponslist-item-btns flex-row btn-clipboard"
                  id="btnH5"
                  @click="_downloadAPP(1)"
                  data-clipboard-target="#hello"
                >去APP领取</div>
                <input type="hidden" id="hello" value style="display:none;" />
              </template>
              <div
                v-else-if="item.status == 1"
                :class="'couponslist-item-btns flex-row '+(item.award_info.code_type==1?'':'couponslist-item-btns2')"
                @click="goAward(item)"
              >{{(item.award_info.code_type==1?'查看':'已领取')}}</div>
              <div v-else class="couponslist-item-btns flex-row couponslist-item-btns2">已过期</div>
            </div>
            <div
              class="couponslist-item-bottom flex-row"
              @click="useClick(i)"
              :class="{'couponslist-item-bottom2':item.status == 1}"
            >
              使用说明
              <img v-if="item.isShow==false" src="../../static/images/pack-down.png" alt />
              <img v-else src="../../static/images/pack-up.png" alt />
            </div>
          </div>
          <div
            class="couponslist-item-tag flex-row"
            :class="{'couponslist-item-tag2':item.status == 1}"
          >{{item.award_info.sign_mark}}</div>
        </div>

        <!-- 兑换卷已经被使用的样子 -->
        <!-- <div class="couponslist-item flex-row" :class="item.isShow==true?'active':''">
          <div class="couponslist-item-left couponslist-item-left2 flex-column">
            <div>
              <span>{{item.award_id}}</span>元
            </div>
            <div
              v-if="item.award_info.condition_desc"
              class="couponslist-item-scope"
            >{{item.award_info.condition_desc}}</div>
          </div>
          <div class="couponslist-item-right flex-column">
            <div class="flex-row couponslist-item-top">
              <div class="flex-column">
                <div
                  class="couponslist-item-name couponslist-item-name2"
                >{{item.award_info.award_name}}</div>
                <div
                  class="couponslist-item-time"
                >{{item.award_info.val_info}}{{item.award_info.unit}}</div>
              </div>
              <div
                v-if="isapp"
                class="couponslist-item-btns couponslist-item-btns2 flex-row"
                @click="useAward"
              >已使用</div>
              <div
                v-else
                class="couponslist-item-btns couponslist-item-btns2 flex-row"
                @click="_downloadAPP(1)"
              >已使用</div>

              <div
                v-if="isapp"
                class="couponslist-item-btns couponslist-item-btns2 flex-row"
                @click="useAward"
              >已过期</div>
              <div
                v-else
                class="couponslist-item-btns couponslist-item-btns2 flex-row"
                @click="_downloadAPP(1)"
              >已过期</div>
              <input type="hidden" id="hello" value style="display:none;" />
              <div
                v-if="!isapp"
                class="copy-btn btn-clipboard"
                id="btnH5"
                @click="_downloadAPP(1)"
                style="height:100vh;width:100vw;position:fixed;left:0;top:0;opacity:0;z-index:1000;"
                data-clipboard-target="#hello"
              >下载app</div>
            </div>
            <div
              class="couponslist-item-bottom couponslist-item-bottom2 flex-row"
              @click="useClick(i)"
            >
              使用说明
              <img v-if="item.isShow==false" src="../../static/images/pack-down.png" alt />
              <img v-else src="../../static/images/pack-up.png" alt />
            </div>
          </div>
          <div
            class="couponslist-item-tag couponslist-item-tag2 flex-row"
          >{{item.award_info.sign_mark}}</div>
        </div>-->

        <div class="couponslist-rule" v-if="item.isShow && item.award_info">
          <div
            class="couponslist-rule-item"
            v-for="(item1,j) in item.award_info.use_desc"
            :key="j"
          >{{item1}}</div>
        </div>
      </div>

      <!-- 没有奖品 -->
      <div
        v-if="!awardlist || awardlist && awardlist.length <= 0"
        class="couponslist-prize flex-column"
      >
        <div class="couponslist-empty flex-row">
          <img src="../../static/images/empty-box@2x.png" alt />
        </div>
        <div class="couponslist-empty-text">你的奖品空空如也</div>
        <div class="couponslist-empty-btn flex-row" @click="tohome">去抽奖</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Alert from "../components/Alert";
import { List } from "vant";
Vue.use(List);
export default {
  name: "team",
  urlData: null,
  data() {
    return {
      firstloading: false,
      isapp: false,
      pageIndex: 0,
      awardlist: [],
      complete: false,
      van_list_load: false,
      // 规则的初始显示状态
      showRule: false
    };
  },
  methods: {
    // 使用说明
    useClick(i) {
      var t = this;
      t.awardlist[i].isShow = !t.awardlist[i].isShow;
    },
    // 查看奖励
    showModel(i) {
      var t = this;
      var m = t.myteams[i];
      //在app内打开
      var openid = t.urlData.openid;
      var apiurl = `${t.baseurl}/api/service/atv/comm/v1/awards/mine?token=${t.urlData.token}`;
      var params = {
        activityId: t.urlData.a,
        teamId: m.teamId
      };
      if (openid) {
        //openid不为空时，在微信内打开
        params = {
          activityId: t.urlData.a,
          thirdOpenId: openid,
          teamId: m.teamId
        };
        apiurl = `${t.baseurl}/api/atv/comm/v1/awards/mine`;
      }
      console.log(apiurl + ",params:");
      console.log(params);
      t.$http
        .post(apiurl, params)
        .then(res => {
          console.log(apiurl + " success");
          console.log(res);
          if (res.data.code == 0) {
            for (var i = 0; i < res.data.body.length; i++) {
              res.data.body[i].expireformat = t.dateformat(
                "Y-m-d",
                res.data.body[i].validDateEnd
              );
            }
            t.alt.myaward = res.data.body;
            t.alt.showmodel = !t.alt.showmodel;
            console.log("t.alt");
            console.log(t.alt);
          } else {
            t.$Toast(res.msg);
          }
          //错误处理
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    // 隐藏奖励
    hideModel() {
      var t = this;
      t.alt.showmodel = !t.alt.showmodel;
    },

    //获得我的中奖记录
    getteams() {
      var t = this;
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._get("user", "User.getAwardLog", params)
        .then(res => {
          if (res.status == 0) {
            var list = res.data.award_log;
            for (var i = 0; i < list.length; i++) {
              var rule = list[i].award_info.use_desc;
              if (rule) {
                rule = rule.replace(/[\d]+\./g, "");
                rule = rule.split("\n");
              }
              list[i].award_info.use_desc = rule;
              list[i].isShow = false;
              list[i].isOver = new Date(list[i].expires_code_t) <= new Date();
              if (list[i].isOver) list[i].status = 2;
            }

            t.awardlist = list;
            t.complete = true;
            // t.activeSku(0);
          } else {
            t.complete = true;
          }
          t.van_list_load = false;
          t.firstloading = true;
          loading.clear();
        })
        .catch(error => {
          t.van_list_load = false;
          console.log(`error is:${error}`);
          loading.clear();
        });
    },
    //立即使用
    useAward(index) {
      var t = this;
      var info = t.awardlist[index];
      console.log("use award info", info);
      if (info.issku == 1) {
        t.activeSku(index);
        return;
      }
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        award_log_id: info.id
      };
      console.log(params);
      t._get("user", "User.useAward", params)
        .then(res => {
          loading.clear();
          // <el-radio-group v-model="form.code_type">
          //   <el-radio label="0">券码(无需跳转)</el-radio>
          //   <el-radio label="1">短链接(跳转)</el-radio>
          //   <el-radio label="2">二维码/条形码</el-radio>
          // </el-radio-group>;
          if (res.status == "0") {
            t.$toast("领取成功");
            t._deepmain(
              "h5open4",
              "yycj#h5open4#clickbutton#receive",
              2,
              function() {
                t.goAward(info);
              }
            );
          } else {
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },

    //无忧行自营商品
    activeSku(index) {
      var t = this;
      var info = t.awardlist[index];
      console.log("[sku]active", info);
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        award_log_id: info.id
      };
      console.log(params);
      t._get("user", "User.activeSku", params)
        .then(res => {
          loading.clear();
          if (res.status == 0) {
            t.$toast("领取成功");
            t._deepmain(
              "h5open4",
              "yycj#h5open4#clickbutton#receive",
              2,
              function() {
                console.log("---打开优惠券列表---");
                try {
                  Jegotrip.openRnPage(
                    JSON.stringify({ funType: "couponsview", funParams: {} })
                  );
                } catch (e) {
                  this.$Toast("网络不给力，请稍后再试");
                }
              }
            );
          } else {
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },

    // 处理跳转，已领取的也可以跳转
    goAward(info) {
      var t = this;
      console.log("[nosku]go award", info);
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "正在跳转..."
      });
      //&& info.award_info.isme == 1 || info.issku == 1
      if (info.award_info.code_type == 0 || info.award_info.code_type == 3) {
        console.log("---打开优惠券列表---");
        try {
          Jegotrip.openRnPage(
            JSON.stringify({ funType: "couponsview", funParams: {} })
          );
        } catch (e) {
          t.$Toast("网络不给力，请稍后再试");
        }
        loading.clear();
      }
      if (info.award_info.code_type == 1) {
        var re_href = info.award_code;
        if (re_href.indexOf("://") < 0) re_href = "http://" + info.award_code;
        window.location.href = re_href;
        loading.clear();
      }
    },

    tohome() {
      var t = this;
      t.$router.push({
        path: "/home",
        query: {}
      });
    }
  },
  components: {
    Alert
  },
  computed: {
    myawardlist: function() {
      var t = this;
      console.log(t.awardlist);
      return t.awardlist.sort(function(a, b) {
        return a.status - b.status;
      });
    }
  },
  created() {
    var t = this;
    var userAgent = window.navigator.userAgent.toLowerCase();
    this.isapp = userAgent.match(/jegotrip/i) == "jegotrip";
    t.urlData = t.$route.query;
    console.log("t.urlData", t.urlData);
    t.getteams();
  }
};
</script>

<style scoped  lang="scss" src="../../static/scss/team.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
.couponslist-item-scope {
  width: 19vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}
</style>



<!-- Add "scoped" attribute to limit CSS to this component only -->
